import { useState, useEffect } from 'react';
import { getGorevSayaci } from '../services/toplantiService';
import { gorevDegisikliginiDinle } from '../utils/gorevYenileme';

const YENILEME_ARALIGI_MS = 5 * 60 * 1000;

/**
 * Üst çubuktaki zilin sayısı: sorumlusu olunan, son günü bugün ya da geçmiş açık
 * görevler. Beş dakikada bir ve görev değişince (kapatma, erteleme, aktarma, not)
 * yeniden çekilir. İstek düşerse önceki sayı kalır.
 */
export const useGorevSayaci = (): number => {
  const [sayi, setSayi] = useState(0);

  useEffect(() => {
    let bitti = false;
    const cek = () => {
      getGorevSayaci()
        .then((res) => { if (!bitti) setSayi(res.data.sayi); })
        .catch(() => {});
    };
    cek();
    const aralik = setInterval(cek, YENILEME_ARALIGI_MS);
    const dinlemeyiBirak = gorevDegisikliginiDinle(cek);
    return () => {
      bitti = true;
      clearInterval(aralik);
      dinlemeyiBirak();
    };
  }, []);

  return sayi;
};
